import { render } from "./TabbyTime.vue?vue&type=template&id=70dc06c0&scoped=true"
import script from "./TabbyTime.vue?vue&type=script&lang=js"
export * from "./TabbyTime.vue?vue&type=script&lang=js"

import "./TabbyTime.vue?vue&type=style&index=0&id=70dc06c0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-70dc06c0"

export default script